import React from "react";
import { Helmet } from 'react-helmet';
import config from '../../config';

function SEO({ type = `website`, 
    image = config.pathPrefix + "/icons/logoBlue.png",description = config.description, 
    lang = "En", 
    meta, 
    keywords=[config.keywords], 
    title = config.siteTitle, 
    author = config.manifestShortName, 
    site = config.url }) {
    return (
        <Helmet
            htmlAttributes={{
                lang
            }}
            title={title}
            titleTemplate={`%s | ${config.siteName}`}
            meta={[
                {
                    name: `author`,
                    property: `author`,
                    content: author
                },
                {
                    name: `viewport`,
                    content: "width=device-width, initial-scale=1.0"
                },
                {
                    name: `title`,
                    property: `og:title`,
                    content: title
                },
                {
                    name: `description`,
                    content: description
                },
                {
                    property: `image`,
                    content: `${config.url}${image}`
                },
                {
                    name: `description`,
                    property: `og:description`,
                    content: description
                },
                {
                    name: `type`,
                    property: `og:type`,
                    content: type
                },
                {
                    property: `og:url`,
                    content: `${ config.url }${ config.pathPrefix }`
                },
                {
                    name: `image`,
                    property: `og:image`,
                    content: `${config.url}${image}`
                },
                {
                    name: `twitter:card`,
                    content: `summary`
                },
                {
                    name: `twitter:creator`,
                    content: description
                },
                {
                    name: `twitter:title`,
                    content: title
                },
                {
                    name: `twitter:description`,
                    content: description
                },
                {
                    name: `keywords`,
                    content: (keywords||[]).join(", ")
                }
            ]}>
            <link rel="canonical" href={site} />

        </Helmet>
    );
}



export default SEO;
